import { PayloadAction } from "@reduxjs/toolkit";
import { SavedCollectionsState } from "@/components/SavedCollectionsListing/redux/types";

const SavedCollectionsReducer = {
  setSavedArticles: (state: SavedCollectionsState, action: PayloadAction<any>) => {
    state.savedArticles = action.payload;
  },
  setSavedVideos: (state: SavedCollectionsState, action: PayloadAction<any>) => {
    state.savedVideos = action.payload;
  },
  setCurrentCollection: (state: SavedCollectionsState, action: PayloadAction<any>) => {
    state.currentCollection = action.payload;
  },
  setLoading: (state: SavedCollectionsState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: SavedCollectionsState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
};

export default SavedCollectionsReducer;
